module.exports = __webpack_public_path__ + "static/media/benz-cover.c6e31c8e.jpg";